export enum RoleType {
  FE045_OP = 'fe045_op',
  VENUE = 'venue',
}
